var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('gft-tabs',{attrs:{"tabs":_vm.types,"theme":"large","margin":Number(48),"selected":_vm.type},on:{"change":_vm.changeType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }